module.exports = __webpack_public_path__ + "static/media/mouse4.796355eb.webp";